// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconStarPath = 'M4.298 9.151 6.01 10.82a3.024 3.024 0 0 1 .87 2.678l-.404 2.355 2.115-1.111a3.017 3.017 0 0 1 2.816 0l2.116 1.111-.405-2.355a3.028 3.028 0 0 1 .871-2.679L15.7 9.151l-2.364-.344a3.021 3.021 0 0 1-2.279-1.655L9.999 5.009 8.941 7.152a3.02 3.02 0 0 1-2.278 1.655l-2.365.344Zm11.881 10.358-5.702-2.998a1.033 1.033 0 0 0-.955 0l-5.703 2.998 1.089-6.349a1.02 1.02 0 0 0-.294-.907L0 7.755l6.376-.926c.334-.049.622-.259.772-.562L9.999.49l2.851 5.777c.15.303.439.513.773.562l6.375.926-4.613 4.497a1.023 1.023 0 0 0-.295.908l1.089 6.349Z';
var IconStar = baseIcon('IconStar', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconStarPath
});
export default IconStar;
//# sourceMappingURL=index.js.map